import { createSelector } from 'reselect';
var selectState = function (state) { return state.get('primaryCategory'); };
export var selectAll = createSelector(selectState, function (state) {
    return state.get('data');
});
export var selectLoadingAll = createSelector(selectState, function (state) {
    return state.get('loadingAll');
});
export var selectShouldLoadAll = createSelector(selectState, function (state) { return !state.get('loadingAll') && !state.get('loadedAll'); });
